import { StaticExperimentMultiVariants } from '@ria-client/supergraph/utils/params/constants';
import { STATIC_EXPERIMENT_CONFIG } from '../experiments';
import {
  isBinaryExperiment,
  isMultiVariateExperiment,
} from '../experiments/isMultiVariateExperiment';
import { SupportedExperimentVariants } from './types';

export const isStaticExperiment = (experimentName: string) => {
  return Object.values(STATIC_EXPERIMENT_CONFIG).includes(experimentName);
};

export function isStaticExperimentActive(
  experimentId: string,
  path: string,
  experimentDecision: SupportedExperimentVariants,
) {
  if (STATIC_EXPERIMENT_CONFIG[path] !== experimentId) {
    return false;
  }

  if (isMultiVariateExperiment(path)) {
    return [
      StaticExperimentMultiVariants.Treatment1,
      StaticExperimentMultiVariants.Treatment2,
    ].includes(experimentDecision as StaticExperimentMultiVariants);
  }

  if (isBinaryExperiment(path)) {
    return experimentDecision === 'treatment';
  }

  return false;
}
